import { type MakePaymentInput, gqlClient, graphql } from '@tyro/api';

const createPaymentMutation = graphql(/* GraphQL */ `
  mutation createPayment($input: MakePaymentInput) {
    fees_createPayment(input: $input) {
      clientSecret
    }
  }
`);

export function createPayment(input: MakePaymentInput) {
  return gqlClient.request(createPaymentMutation, { input });
}
